class LoadActu {

    limit = undefined;
    page = undefined;
    #selectorComponent = undefined;
    #ajax_url = undefined;
    #action = undefined;
    #paramArrayName = undefined;
    #layout = undefined;

    constructor(
        selectorComponent = "ajax-loaded",
        ajax_url = "/wp-admin/admin-ajax.php",
        action = "actualites",
        paramArrayName = "actualites",
        limit = 4,
        page = 1
    ) {
        this.limit = limit;
        this.page = page;
        this.#selectorComponent = selectorComponent;
        this.#ajax_url = ajax_url;
        this.#action = action;
        this.#paramArrayName = paramArrayName;
        this.init();
    }

    init() {
        const componentsAjaxLoaded = Array.from(jQuery('.' + this.#selectorComponent));

        if (componentsAjaxLoaded.length > 0) {
            componentsAjaxLoaded.forEach(component => {
                this.eventBtnPagination(jQuery(component).find(".pagination a.page-link"));
            });
        }
    }

    eventBtnPagination(linksPagination) {
        const instance = this;
        linksPagination.on('click', function (e) {
            e.preventDefault();
            instance.manageParams(this);
            instance.query();
        });
    }

    manageParams(btn) {
        let params = null;

        if (btn.href != "" && btn.href != null && btn.href != undefined) {
            params = (new URL(btn.href)).searchParams;
        }

        if (typeof params.entries()[Symbol.iterator] == "function") {

            for (var pair of params.entries()) {

                if (pair[0] == this.#paramArrayName + "[page]") {
                    this.page = pair[1];
                }
            }
        }
    }

    query() {

        const instance = this;
        jQuery.ajax({
            url: instance.#ajax_url,
            type: "GET",
            data: {
                'action': instance.#action,
                'actualites': {
                    'page': instance.page,
                    'limit': instance.limit
                }
            },
            beforeSend: function () {
                instance.#addLoader();
            },
        }).done(function (response) {

            const resFormated = jQuery(response);

            if (resFormated.has("div").length > 0) {
                instance.#layout = resFormated;
                instance.#refreshLayout();
            }
            else {
                instance.#layout = undefined;
            }

        });
    }

    #refreshLayout() {
        jQuery("." + this.#selectorComponent).empty();
        jQuery("." + this.#selectorComponent).html(this.#layout);
        jQuery("." + this.#selectorComponent + " ." + this.#selectorComponent).unwrap("." + this.#selectorComponent);
        jQuery("." + this.#selectorComponent).find("ul.row li .card").attr("tabindex", "0");
        jQuery("." + this.#selectorComponent).find("ul.row > li:first-child .card").focus();
        new LoadActu();
    }

    #addLoader() {
        jQuery("." + this.#selectorComponent).find("ul.row").remove();
        jQuery("." + this.#selectorComponent).find(".container-fluid").addClass("d-flex");
        jQuery("." + this.#selectorComponent).find(".container-fluid").append(this.#loader());
    }

    #loader() {
        return `
        <div class="spinner m-auto">
            <div class="spinner-border" role="status">
                <p class="sr-only">Chargement...</span>
            </div>
        </div>
        `;
    }

}

new LoadActu(
    'ajax-loaded',
    '/wp-admin/admin-ajax.php',
    'actualites',
    'actualites',
    4,
    1
);